import jQuery from 'jquery';

jQuery(function($) {
  let $step = $('.step');
  let $stepList = $step.find('.step__list');
  let $stepItem = $stepList.find('.step__item');
  let timeouts = [];

  $stepItem.on('mouseenter touchstart touchmove', function(event) {
    let delay = 50;
    let $item = $(this);
    let $itemPrevs = $item.prevAll();

    $item.nextAll().removeClass('step__item--active');

    $($itemPrevs.get().reverse()).each(function() {
      let $itemPrev = $(this);

      if (!$itemPrev.hasClass('step__item--active')) {
        timeouts[$itemPrev.data('step')] = setTimeout(function() {
          $itemPrev.addClass('step__item--active');
        }, delay);

        delay += 50;
      }
    });

    timeouts[$item.data('step')] = setTimeout(function() {
      $item.addClass('step__item--active');
    }, delay);
  });

  $stepItem.on('mousemove', function() {
    $(this).nextAll().removeClass('step__item--active');
  });

  $stepList.on('mouseleave', function(event) {
    for (let i = 0; i <= $stepItem.length; i++) {
      if (timeouts[i] !== undefined) {
        clearTimeout(timeouts[i]);
      }
    }

    $stepItem.removeClass('step__item--active');
  });
});
